<template>
<!--::::::::::::::::::::::::::::::::::::::::::::::::
    Modal - AUMAへようこそ
::::::::::::::::::::::::::::::::::::::::::::::::-->
<div class="modal_container _register-promotion">
    <div class="modal_bg _register-promotion"></div>
    <div class="wrap">
        <!-- Title -->
        <div class="title">
            <h3><span>AUMAへようこそ</span></h3>
            <h4><span>無料登録してさらに多くの<br class="_sp">ブランドをチェック</span></h4>
        </div><!-- /.Title -->
        <!-- Text -->
        <div class="text-wrap">
            <div class="inner">

                <!-- Button -->
                <div class="button-wrap">
                    <div class="btn_link-wrap">
                        <a href="/registration/shop" class="btn_link"><span>ショップ・個人<br class="_sp">（登録）</span></a>
                        <div class="bg-element"></div>
                    </div>
                    <div class="btn_link-wrap">
                        <a href="/registration?register=brand" class="btn_link"><span>ブランド<br class="_sp">（登録・掲載）</span></a>
                        <div class="bg-element"></div>
                    </div>
                    <div class="btn_link-wrap">
                        <a href="/registration?register=showroom" class="btn_link"><span>ショールーム<br class="_sp">（登録・掲載）</span></a>
                        <div class="bg-element"></div>
                    </div>
                </div><!-- /.button-wrap -->

                <p class="text">または</p>

                <!-- Button -->
                <div class="button-wrap">
                    <div class="btn_link-wrap">
                        <a href="/login" class="btn_link"><span>アカウントをお持ちの方はこちら</span></a>
                        <div class="bg-element"></div>
                    </div>
                </div><!-- /.button-wrap -->


            </div><!-- /.Inner -->
        </div><!-- /.Text -->
        <div class="close-icon" v-on:click="modalCloseClick"><span></span><span></span></div>
    </div><!-- /.Wrap -->
    <div class="modal_close-ovl" v-on:click="modalCloseClick"></div>
</div><!-- /.ModalContainer -->
</template>

<script>
    export default {
        methods: {
            modalCloseClick() {
                console.log('ssss')
                location.href = route('end_user.top');
            }
        }
    }
</script>

<style scoped>
.md_fixed-logo {
    opacity: 0;
}

._register-promotion .title h3 {
    font-size: 1.5rem;
}

.modal_container._register-promotion {
    z-index: 100000;
}

.modal_container._register-promotion .wrap {
    z-index: 1000000;
}

.modal_container._register-promotion .wrap .text-wrap .button-wrap {
    border-top: none;
    margin-top: 0;
    padding-top: 0;
}

.modal_container._register-promotion .wrap .text-wrap p.text {
    margin: 3rem 0 2rem;
    text-align: center;
}

.modal_bg._register-promotion {
    z-index: 999999;
}
.close-icon, .modal_close-ovl {
    z-index: 999999;
}
._sp {
    display: none;
}
@media only screen and (max-width: 580px) {
    .modal_container .wrap .text-wrap .button-wrap .btn_link-wrap {
        width: 100%;
    }
    ._sp {
        display: block;
    }
}
</style>
